import { useContext } from 'react';

import { GlobalModalsContext } from './GlobalModalsContext';

export const useGlobalModals = () => {
  const context = useContext(GlobalModalsContext);
  if (!context) {
    throw new Error('useGlobalModals must be used within GlobalModalsProvider');
  }
  return context;
};
